import productMaster from './products.json';

export const asset = (name) => name ? `/assets/images/${name}` : '';

const categoryDescriptions = {
  ceiling: 'Reliable airflow for everyday living, with a range of KIZAK ceiling fans built around practical performance and considered design.',
  pedestal: 'Flexible high-volume airflow for rooms and work areas where portable circulation matters.',
  cabin: 'Compact ventilation for focused spaces, with practical sizes and dependable bearing systems.',
  'table-wall': 'Versatile table and wall airflow solutions for everyday rooms and workspaces.',
  'table-wall-moving': 'Oscillating table and wall fans designed to distribute airflow across a wider area.',
  'fresh-air': 'Fresh-air circulation solutions for spaces that need dependable air movement and ventilation.',
  ventilation: 'Compact ventilation fans designed to move stale air out of enclosed spaces.',
  'extension-cords': 'KIZAK copper-wire extension cords for practical power distribution around the home and workspace.',
  'roto-grill': 'Roto grill airflow with a focused design for everyday ventilation needs.',
};

export const products = productMaster.products.map((product) => ({
  ...product,
  image: product.media?.primary ?? null,
  images: product.media?.gallery ?? [],
  categoryId: product.categorySlug,
  price: product.pricing?.retailPrice ?? null,
}));

export const categories = productMaster.categories.map((category) => ({
  ...category,
  slug: category.id,
  desc: categoryDescriptions[category.id] ?? `Explore KIZAK ${category.name.toLowerCase()} designed for dependable everyday comfort.`,
  image: null,
}));

export const siteConfig = {
  brand: 'KIZAK',
  tagline: 'Innovating Comfort, Delivering Excellence',
  email: 'customercare@kizakindia.com',
  phone: '+91 97758 036615',
  currency: 'INR',
};

export const testimonials = [];
export const testimonialImages = [];
export const feed = [];



export const getProductBySlug = (slug) => products.find((product) => product.slug === slug);
export const getProductsByCategory = (slug) => products.filter((product) => product.categorySlug === slug);
export const getCategoryBySlug = (slug) => categories.find((category) => category.slug === slug);
